import React, { useEffect, useState } from "react";
import {
  DivGeral,
  SpanTitulo,
  DivContainer,
  SpanSubtitulo,
  ContentSearch,
  ContentResultado,
  ContainerComBorda,
  ContainerMapa,
  ContainerInfoMapa,
  InfoMapa,
} from "./inicio-estilo";
import { Button, TextField } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { TabelaPaginada } from "../../componentes/TabelaPaginada";
import { MapaLeaflet } from "../../componentes/mapa-leaflet/MapaLeaflet";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import { getDadosImovel, getDadosTabelaHistoricoUsoSolo } from "../../services/api/fusio";
import { useDispatch } from "react-redux";
import {
  decrementLoad,
  incrementLoad,
  setToastMessage,
  setToastType,
} from "../../redux/reducer";

const Inicio = () => {
  const [exibeResultado, setExibeResultado] = useState(false);
  const [bbox, setBbox] = useState(null);
  const [numeroCar, setNumeroCar] = useState("");
  const [dadosImovel, setDadosImovel] = useState({});
  const dispatch = useDispatch();
  const [larguraTela, setLarguraTela] = useState(window.innerWidth);

  useEffect(() => {
    const atualizarLarguraTela = () => setLarguraTela(window.innerWidth);
    window.addEventListener("resize", atualizarLarguraTela);
    return () => window.removeEventListener("resize", atualizarLarguraTela);
  }, []);

  const colunasTabela = [{ nome: "Indice" }, { nome: "Nome" }];

  const dadosTabela = [
    { index: 1, nome: "Série Histórica" },
    { index: 2, nome: "Cartograma" },
    { index: 3, nome: "Tabela Sintese" },
  ];

  const optionsCombo = [
    {
      nome: () => "Gerar PDF",
      desabilitarOpcao: () => false,
      icon: () => <PictureAsPdfIcon />,
      onClick: (user) => {
        if (user.index === 1) window.open(`/pdfSerieHistoria/${numeroCar}`);
        if (user.index === 2) window.open(`/pdfCartogramaPrint/${numeroCar}`);
        if (user.index === 3) window.open(`/pdfTabelaSintese/${numeroCar}`);
      },
    },
  ];

  const milionSeparator = (valorStr) => {
    if (!valorStr || valorStr === "NaN") return "0,00";
    const [a, bRaw] = valorStr.includes(",") ? valorStr.split(",") : [valorStr, "00"];
    const b = (bRaw ?? "00").padEnd(2, "0");
    const c = Array.from(a)
      .reverse()
      .map((ch, idx) => (idx > 0 && idx % 3 === 0 ? `${ch}.` : ch))
      .reverse()
      .join("");
    return `${c},${b}`;
  };

  function parseTabelaHistorico(resp) {
    let tabelaEntry;
    if (Array.isArray(resp)) {
      tabelaEntry = resp;
    } else if (resp && resp.entry) {
      tabelaEntry = resp.entry;
    } else {
      tabelaEntry = [];
    }
    if (!tabelaEntry.length) return [];

    const row0 = tabelaEntry[0];
    const anos = Object.keys(row0).filter((k) => /^\d{4}$/.test(k));
    return anos
      .map((ano) => {
        const val = row0[ano];
        let parsed = [];
        try {
          parsed = typeof val === "string" ? JSON.parse(val) : (val || []);
        } catch (e) {
          console.error(`[Inicio] JSON inválido no ano ${ano}:`, e);
          parsed = [];
        }
        return { ano, dados: parsed };
      })
      .sort((a, b) => Number(a.ano) - Number(b.ano));
  }

  function normalizeTexto(valor) {
    if (valor == null) return "";
    return String(valor)
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function deParaUso(header, uso) {
    const h = normalizeTexto(header);
    const u = normalizeTexto(uso);
    if (h === "pastagem" && u === "pastagem natural ou plantada") return true;
    if (h === "agricultura" && u === "agricultura") return true;
    if (h === "agropecuaria" && u === "mosaico de agricultura e pastagem") return true;
    if (h === "silvicultura" && u === "silvicultura") return true;
    if (h === "natural nao vegetada" && u === "areas nao vegetadas") return true;
    if (h === "vegetacao florestal" && u === "vegetacao natural florestal") return true;
    if (h === "vegetacao nao florestal" && u === "vegetacao natural nao florestal") return true;
    if (h === "infraestrutura" && u === "area de influencia urbana") return true;
    if (h === "agua" && u === "agua e aquicultura") return true;
    return false;
  }

  function pickArea(dadosAno, header) {
    if (!dadosAno || !Array.isArray(dadosAno)) return 0;
    const item = dadosAno.find((d) => deParaUso(header, d.uso));
    const area = parseFloat(item?.area ?? 0);
    return Number.isFinite(area) ? area : 0;
  }

  const pesquisar = async () => {
    const car = (numeroCar || "").trim();
    if (!car) {
      dispatch(setToastType("warning"));
      dispatch(setToastMessage("Digite o numero do CAR!"));
      return;
    }

    try {
      dispatch(incrementLoad());
      console.error("[Inicio] Iniciando carga para CAR:", car);
      const [imovelResult, historicoResult] = await Promise.allSettled([
        getDadosImovel(car),
        getDadosTabelaHistoricoUsoSolo(car),
      ]);

      if (imovelResult.status !== "fulfilled") {
        throw imovelResult.reason;
      }

      const response = imovelResult.value.data;
      if (historicoResult.status !== "fulfilled") {
        const status = historicoResult.reason?.response?.status;
        const serverMsg =
          historicoResult.reason?.response?.data?.message ||
          historicoResult.reason?.response?.data?.error;
        console.error(
          "[Inicio] Falha ao buscar tabela_historico_uso_solo:",
          status,
          serverMsg || historicoResult.reason?.message || historicoResult.reason
        );
      } else {
        console.error(
          "[Inicio] tabela_historico_uso_solo OK:",
          Array.isArray(historicoResult.value?.data)
            ? `rows=${historicoResult.value.data.length}`
            : "obj",
          "keys=",
          Array.isArray(historicoResult.value?.data) && historicoResult.value.data[0]
            ? Object.keys(historicoResult.value.data[0]).slice(0, 5)
            : Object.keys(historicoResult.value?.data || {}).slice(0, 5)
        );
      }
      const historicoResp =
        historicoResult.status === "fulfilled" ? historicoResult.value.data : null;

      // trata o serviço como ARRAY
      const item = Array.isArray(response) ? response[0] : response;
      if (!item) throw new Error("Resposta vazia do serviço.");

      const areaTotalStr = milionSeparator(
        parseFloat(item.num_area ?? 0).toFixed(2).replace(/\./g, ",")
      );
      const historico = parseTabelaHistorico(historicoResp);
      const dados2021 = historico.find((d) => d.ano === "2021")?.dados || [];
      if (!dados2021.length) {
        console.warn("[Inicio] Sem dados de 2021 em tabela_historico_uso_solo.", {
          anos: historico.map((h) => h.ano),
        });
      }

      const agricultura2021 = pickArea(dados2021, "Agricultura");
      const agropecuaria2021 = pickArea(dados2021, "Agropecuária");
      const pastagem2021 = pickArea(dados2021, "Pastagem");
      const vegetacaoFlorestal2021 = pickArea(dados2021, "Vegetação florestal");
      const vegetacaoNaoFlorestal2021 = pickArea(dados2021, "Vegetação não florestal");
      const vegetacao2021 = vegetacaoFlorestal2021 + vegetacaoNaoFlorestal2021;

      const vegetacaoStr = milionSeparator(
        parseFloat(vegetacao2021 ?? 0).toFixed(2).replace(/\./g, ",")
      );
      const areaAgricolaTotal2021 = agricultura2021 + agropecuaria2021 + pastagem2021;
      const areaAgricolaStr = milionSeparator(
        parseFloat(areaAgricolaTotal2021 ?? 0).toFixed(2).replace(/\./g, ",")
      );

      setDadosImovel({
        areaTotal: areaTotalStr,
        vegetacao: vegetacaoStr,
        areaAgricola: areaAgricolaStr,
        codigoImovel: item.cod_imovel,
        geom: item.geom, // pode ser WKT ("POLYGON...") ou GeoJSON
      });

      // calcula bbox a partir do GeoJSON ou WKT
      const computedBbox = getBoundsFromGeom(item.geom);
      setBbox(computedBbox);

      setExibeResultado(true);
    } catch (e) {
      console.error("Erro ao pesquisar: ", e);
      dispatch(setToastType("error"));
      dispatch(setToastMessage("Número CAR inválido!"));
      setExibeResultado(false);
    } finally {
      dispatch(decrementLoad());
    }
  };

  // --- helpers: WKT -> GeoJSON (Polygon/MultiPolygon simples) ---
  function wktToGeoJSON(wkt) {
    if (!wkt || typeof wkt !== "string") return null;
    const s = wkt.trim();

    if (/^POLYGON\s*\(\(/i.test(s)) {
      const inner = s.replace(/^POLYGON\s*\(\(/i, "").replace(/\)\)\s*$/, "");
      const rings = inner.split("),(");
      const coordinates = rings.map((ring) =>
        ring.split(",").map((pair) => {
          const [x, y] = pair.trim().split(/\s+/).map(Number); // lon, lat
          return [x, y];
        })
      );
      return { type: "Polygon", coordinates: [coordinates[0], ...coordinates.slice(1)] };
    }

    if (/^MULTIPOLYGON\s*\(\(\(/i.test(s)) {
      const inner = s.replace(/^MULTIPOLYGON\s*\(\(\(/i, "").replace(/\)\)\)\s*$/, "");
      const polys = inner.split(")),((");
      const coordinates = polys.map((poly) => {
        const rings = poly.split("),(");
        const ringCoords = rings.map((ring) =>
          ring.split(",").map((pair) => {
            const [x, y] = pair.trim().split(/\s+/).map(Number);
            return [x, y];
          })
        );
        return [ringCoords[0], ...ringCoords.slice(1)];
      });
      return { type: "MultiPolygon", coordinates };
    }

    return null;
  }

  // extrai bounds [ [latMin,lngMin], [latMax,lngMax] ] do GeoJSON ou WKT
  function getBoundsFromGeom(geom) {
    let geo = geom;
    if (!geo) return null;

    if (typeof geo === "string") {
      geo = wktToGeoJSON(geo);
      if (!geo) return null;
    }

    if (!geo.type || !geo.coordinates) return null;

    let coords = [];
    if (geo.type === "Polygon") {
      coords = geo.coordinates.flat(); // [ [lon,lat], ... ]
    } else if (geo.type === "MultiPolygon") {
      coords = geo.coordinates.flat(2);
    } else {
      return null;
    }

    const lats = coords.map((c) => c[1]);
    const lngs = coords.map((c) => c[0]);

    const latMin = Math.min(...lats);
    const latMax = Math.max(...lats);
    const lngMin = Math.min(...lngs);
    const lngMax = Math.max(...lngs);

    return [
      [latMin, lngMin],
      [latMax, lngMax],
    ];
  }

  const getTamanhoMapa = () => {
    if (larguraTela >= 1200) return "500px";
    if (larguraTela >= 900 && larguraTela < 1199) return "400px";
    if (larguraTela >= 500 && larguraTela < 899) return "300px";
    return "70vw";
  };

  const Resultado = () => (
    <ContentResultado $marginCelular={larguraTela < 700}>
      <ContainerComBorda style={{ marginBottom: 20 }}>
        <ContainerMapa>
          <div
            style={{
              width: `${getTamanhoMapa()}`,
              height: "300px",
              marginTop: 10,
              marginBottom: 10,
              backgroundColor: "green",
            }}
          >
            <MapaLeaflet
              codigoImovel={dadosImovel.codigoImovel}
              bbox={bbox}
              geom={dadosImovel.geom}
            />
          </div>
          <ContainerInfoMapa>
            <InfoMapa>Área total: {dadosImovel.areaTotal}ha</InfoMapa>
            <InfoMapa>Área agrícola: {dadosImovel.areaAgricola}ha</InfoMapa>
            <InfoMapa>Vegetação: {dadosImovel.vegetacao}ha</InfoMapa>
          </ContainerInfoMapa>
        </ContainerMapa>
      </ContainerComBorda>

      <TabelaPaginada
        colunas={colunasTabela}
        showAcoes={true}
        acoes={optionsCombo}
        dados={dadosTabela}
        showPaginacao={false}
      />
    </ContentResultado>
  );

  return (
    <div className={exibeResultado ? "fundo" : "background-degrade-fundo"}>
      <DivGeral>
        <SpanTitulo style={{ fontSize: larguraTela > 700 ? 38 : 18 }}>
          Sistema de Apoio à Caracterização de Imóveis Rurais
        </SpanTitulo>
        <DivContainer>
          <SpanSubtitulo style={{ fontSize: larguraTela > 700 ? 30 : 18 }}>
            Obtenha Informações sobre o seu imóvel
          </SpanSubtitulo>
          <ContentSearch>
            <TextField
              style={{ width: "80%" }}
              value={numeroCar}
              placeholder="Digite o numero do CAR"
              onChange={(e) => {
                setNumeroCar(e.target.value);
                setExibeResultado(false);
              }}
            />
            <Button
              style={{ width: "8%", marginLeft: "2%" }}
              onClick={() => {
                setNumeroCar("");
                setExibeResultado(false);
              }}
              variant="outlined"
            >
              <DeleteIcon />
            </Button>
            <Button
              variant="contained"
              style={{ width: "8%", marginLeft: "2%" }}
              onClick={pesquisar}
            >
              <SearchIcon />
            </Button>
          </ContentSearch>

          {exibeResultado && <Resultado />}
        </DivContainer>
      </DivGeral>
    </div>
  );
};

export default Inicio;
